module.exports = __webpack_public_path__ + "static/media/IconNFC.f9e8b190.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/IconNFC.svg
// module id = 316
// module chunks = 0